module.exports = __webpack_public_path__ + "img/game-icon-01.e238bb5c.png";